import React from "react";
import styled from "styled-components";
import get from "lodash/get";
import { BLOCKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import SectionTitle from "../../common/Section/SectionTitle";
import GatsbyImage from "gatsby-image";

const Wrap = styled.div`
  * {
    transition: all 0.3s ease;
  }
  img {
    width: 100%;
  }
`;

const ThreeLittlePigs = ({ data }) => {
  // console.log('data: ', data);
  const richText1 = get(data, "richText1");
  const json = get(richText1, "json");
  const titleCopy = get(json, "content[0].content[0].value");
  const fileRef = get(data, "fileRef");
  const fluid = get(fileRef, "fluid");
  const title = get(fileRef, "title");
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: () => null,
      // [BLOCKS.EMBEDDED_ASSET]: (node) => {
      //   // console.log('node: ', node);
      //   const fields = get(node, "data.target.fields");
      //   const imgUrl = get(fields, "file['en-US'].url");
      //   const imgTitle = get(fields, "title");
      //   return <img src={imgUrl} alt={imgTitle} />
      // }
    },
  };

  return (
    <Wrap>
      <SectionTitle copy={titleCopy} titleColor="black" bold />
      {documentToReactComponents(json, options)}
      <GatsbyImage fluid={fluid} alt={title} />
    </Wrap>
  );
};

export default ThreeLittlePigs;
